import {
  LOADING_CUSTOMFIELD,
  LOAD_CUSTOMFIELD,
  CUSTOMFIELD_SAVE_REQUEST,
  CUSTOMFIELD_SAVE_SUCCESS,
  FETCH_CUSTOMFIELD_REQUEST,
  FETCH_CUSTOMFIELD_REQUEST_SUCCESS,
} from "../types/customfield.types";

export interface ICustomField {
  id: string;
  field_label: string;
  field_type: string;
  required_field: string;
  field_options: string;
  field_status: any;
  field_metadata: any;
  signup_field: any;
}

export type customFieldStateType = {
  customfields: null | ICustomField[];
  customfield: null | ICustomField;
  total: number;
  current: number;
  loading: boolean;
  save: boolean;
};

const initialState: customFieldStateType = {
  customfields: null,
  customfield: null,
  total: 0,
  current: 1,
  loading: false,
  save: false,
};

export default function customfieldReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOAD_CUSTOMFIELD:
      return {
        loading: false,
        customfields: action.payload.results,
        total: action.payload.count,
        current: action.payload.current,
      };
    case LOADING_CUSTOMFIELD:
    case FETCH_CUSTOMFIELD_REQUEST:
      return {
        ...state,
        customfield: null,
        loading: true,
      };
    case CUSTOMFIELD_SAVE_REQUEST:
      return {
        ...state,
        save: false,
      };
    case CUSTOMFIELD_SAVE_SUCCESS:
      return {
        ...state,
        save: true,
        cusomfield: null,
      };
    case FETCH_CUSTOMFIELD_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        customfield: action.payload,
      };
    default:
      return state;
  }
}
